// extracted by mini-css-extract-plugin
module.exports = {"errorAlert":"NotificationBox_errorAlert__3z525","defaultAlert":"NotificationBox_defaultAlert__27X6h","closebtn":"NotificationBox_closebtn__1HVGT"};